export default __webpack_public_path__ + "static/media/sprint-facilitation.15100b94.svg";